import { Card, CardActionArea, CardMedia, Tooltip } from "@mui/material"
import { ALBUM_COVER_SIZE } from "../../utils/constants/viewConstants";

const SquaredAlbumItem = ({album, onClick}) => {
    const squareSize = ALBUM_COVER_SIZE;

    return (
        <Card sx={{width: squareSize}}>
            <Tooltip title={`${album.name} · ${album.artist}`} placement="right" >
                <CardActionArea onClick={onClick} onContextMenu={onClick}>
                    <CardMedia image={album.images.md.url} sx={{ height: squareSize }} />
                </CardActionArea>
            </Tooltip>
        </Card>
    )
}

export default SquaredAlbumItem;